import React from 'react';

import { Button, Modal } from '../../index';
import ContactForm from '../../forms/ContactForm';
import { useFormModal } from '../../../hooks/useFormModal';

import styles from './styles.module.scss';

const RetirementVillagesButtons = () => {
  const { isOpen: enquireModal, openModal, closeModal } = useFormModal(['enquireForm', 'contactForm']);

  const scrollToVillages = () => {
    const cardIntro = document.querySelector('[class*="cardIntro"]') as HTMLElement;
    if (cardIntro) {
      // Get the element's position
      const elementPosition = cardIntro.getBoundingClientRect().top + window.pageYOffset;

      // Calculate header height dynamically
      const header = document.querySelector('header');
      const headerHeight = header ? header.offsetHeight : 0;

      // Add a small buffer (20px) for better visual spacing
      const offsetPosition = elementPosition - headerHeight - 20;

      // Scroll to the calculated position
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <div className={`${styles.buttonContainer} textMimicH3`}>
        <Button onClick={scrollToVillages} type="solidOrange" large>
          View our villages
        </Button>
        <Button onClick={openModal} type="orangeBorder" large>
          Enquire now
        </Button>
      </div>
      <Modal isOpen={enquireModal} onRequestClose={closeModal} title="Retirement Villages">
        <ContactForm section="Retirement Villages" title="Retirement Villages" />
      </Modal>
    </>
  );
};

export default RetirementVillagesButtons;

